import { render, staticRenderFns } from "./address-book-management.vue?vue&type=template&id=1f4c04a2&scoped=true"
import script from "./address-book-management.vue?vue&type=script&lang=js"
export * from "./address-book-management.vue?vue&type=script&lang=js"
import style0 from "./address-book-management.vue?vue&type=style&index=0&id=1f4c04a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c04a2",
  null
  
)

export default component.exports